@use "../../styles/breakpoint.module.scss" as *;

$below-tablet-small: "max-width: 959px";

.root {
    composes: repeater from "../../styles/layout.module.scss";
    grid-column: content;
}

.single {
    composes: root;
    row-gap: var(--spacer-24);

    > * {
        grid-column: col-start 4 / span 6;

        @media ($below-tablet) {
            grid-column: col-start 3 / span 8;
        }

        @media ($below-tablet-small) {
            grid-column: content;
        }
    }
}

.twoUp {
    composes: root;
    row-gap: var(--spacer-24);

    > *:nth-child(odd) {
        grid-column: content-start / span 6;

        @media ($below-tablet-small) {
            grid-column: content;
        }
    }

    > *:nth-child(even) {
        grid-column: col-start 7 / content-end;

        @media ($below-tablet-small) {
            grid-column: content;
        }
    }
}

.twoUp.open {
    gap: var(--spacer-64) var(--spacer-80);

    > *:nth-child(odd) {
        position: relative;

        &::after {
            content: "";
            position: absolute;
            right: calc(var(--spacer-80) / -2);
            top: 0;
            bottom: 0;
            width: 1px;
            background: var(--mid-gray);
        }

        @media ($below-tablet-small) {
            &::after {
                display: none;
            }
        }
    }
}
